export default __webpack_public_path__ + "static/media/woman-draw-3period.2fd8ea88.svg";